<template>
  <div>Reviews list</div>
</template>

<script>
export default {
  name: "reviews-list-vue",
  selector: ".reviews-list-vue",
}
</script>

<style scoped>

</style>